import React, { useState, useEffect } from 'react';
import { Layout, Button } from 'antd';
import { Link, Outlet, useLocation } from 'react-router-dom';
import { LoginOutlined, HomeOutlined, FileTextOutlined } from '@ant-design/icons';
import { TabBar } from 'antd-mobile';
import { useSiteSettings } from '../../../context/SiteSettingsContext';
import SystemIcon from '../../../components/SystemIcon';
import './PublicLayout.css';

const { Header, Content, Footer } = Layout;

const NAV_ITEMS = [
  { key: '/', label: 'หน้าหลัก', icon: <HomeOutlined /> },
  { key: '/news', label: 'ข่าวสาร', icon: <FileTextOutlined /> },
];

const BOTTOM_TAB_ITEMS = [
  { key: '/', title: 'หน้าหลัก', icon: <HomeOutlined /> },
  { key: '/news', title: 'ข่าวสาร', icon: <FileTextOutlined /> },
  { key: '/login', title: 'เข้าสู่ระบบ', icon: <LoginOutlined /> },
];

const PublicLayout = () => {
  const location = useLocation();
  const { settings } = useSiteSettings();
  const [user, setUser] = useState(null);

  useEffect(() => {
    try {
      const userData = JSON.parse(localStorage.getItem('user'));
      setUser(userData || null);
    } catch {
      setUser(null);
    }
  }, []);

  const isActive = (key) =>
    key === '/' ? location.pathname === '/' : location.pathname.startsWith(key);

  // activeKey สำหรับ Bottom Tab (หน้า /news/:id ยัง active ที่ /news)
  const bottomActiveKey =
    location.pathname.startsWith('/news') ? '/news' : location.pathname;

  return (
    <Layout className="public-layout">
      <Header className="public-header">
        <div className="public-header-inner">
          <Link to="/" className="public-brand">
            <span className="public-brand-icon">
              <SystemIcon icon={settings.system_icon} size={26} />
            </span>
            <span className="public-brand-text">
              <strong>ระบบสารสนเทศคณะสงฆ์ <span className="brand-line2">ภาค ๔-๕ (ธรรมยุต)</span></strong>
              <small>E-Sangha Information Hub</small>
            </span>
          </Link>

          <nav className="public-nav">
            {NAV_ITEMS.map((item) => (
              <Link
                key={item.key}
                to={item.key}
                className={`public-nav-link${isActive(item.key) ? ' active' : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className="public-header-actions">
            <Link to="/login">
              <Button
                type="primary"
                className="public-login-btn"
                icon={<LoginOutlined />}
              >
                {user ? 'เข้าใช้งานระบบ' : 'เข้าสู่ระบบ'}
              </Button>
            </Link>
          </div>
        </div>
      </Header>

      <Content className="public-content">
        <Outlet />
      </Content>

      <Footer className="public-footer">
        <div className="public-footer-inner">
          <div className="public-footer-brand">
            <div className="public-footer-title">ระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธรรมยุต)</div>
            <p>ศูนย์รวมข้อมูลวัด พระสงฆ์ และสถิติรายปี เพื่อการบริหารกิจการคณะสงฆ์อย่างเป็นระบบ</p>
          </div>
          <div className="public-footer-links">
            <span className="public-footer-head">เมนูลัด</span>
            <Link to="/">หน้าหลัก</Link>
            <Link to="/news">ข่าวสาร</Link>
            <Link to="/login">เข้าสู่ระบบ</Link>
          </div>
        </div>
        <div className="public-footer-copy">
          © {new Date().getFullYear()} ระบบสารสนเทศคณะสงฆ์ ภาค ๔-๕ (ธรรมยุต)&nbsp;|&nbsp;พัฒนาโดย บริษัท อะตอมซอฟท์ จำกัด
        </div>
      </Footer>

      {/* Bottom Tab Bar — แสดงเฉพาะจอเล็ก (mobile) */}
      <div className="public-bottom-tab">
        <TabBar
          activeKey={bottomActiveKey}
          onChange={(key) => {
            if (key === '/login' && user) {
              // ถ้า login แล้ว → ไปหน้า dashboard
              window.location.href = '/dashboard';
              return;
            }
            window.location.href = key;
          }}
          safeArea
        >
          {BOTTOM_TAB_ITEMS.map((item) => (
            <TabBar.Item
              key={item.key}
              icon={item.icon}
              title={item.title}
            />
          ))}
        </TabBar>
      </div>
    </Layout>
  );
};

export default PublicLayout;

